import { MakeCall } from 'ha/services/apiV2/createMakeCall';

const deleteListing = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}`);
export { deleteListing };
